import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { TextView } from "../TextView";
import TickIMg from "../../Assets/check2.svg";

function MultiCheckBoxes({
  items,
  checkedItems,
  setCheckedItems,
  setCheckedItemsId,
  isDisabled = true,
}) {
  const handleCheck = (event) => {
    const item = event.target.name;
    const itemId = event.target.name;
    const isChecked = event.target.checked;
    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [item]: isChecked,
    }));
    if (isChecked) {
      setCheckedItemsId((prevCheckedItems) => [
        ...prevCheckedItems,
        Number(itemId),
      ]);
    } else {
      setCheckedItemsId((prevCheckedItems) =>
        prevCheckedItems.filter((id) => id !== Number(itemId))
      );
    }
  };
  const categories = [...new Set(items.map((item) => item.category))];
  return (
    <Grid>
      <div>
        {categories.map((category) => (
          <div key={category}>
            <h3>{category}</h3>
            {isDisabled ? (
              items
                .filter((item) => item.category === category)
                .map((item) => (
                  <FormControlLabel
                    key={item.id}
                    control={
                      <Checkbox
                        disabled={!isDisabled}
                        checked={checkedItems[item.id] || false}
                        onChange={handleCheck}
                        name={item.id}
                      />
                    }
                    label={item.name}
                  />
                ))
            ) : (
              <Grid item container alignItems="center">
                <Typography color="#4c5a6a" fontWeight={600}>
                  General Information
                </Typography>
                {items
                  .filter((item) => checkedItems[item.id])
                  .map((val) => {
                    return (
                      <Box
                        sx={{
                          backgroundColor: "#effef5",
                          display: "flex",
                          width: "fit-content",
                          flexDirection: "row",
                          padding: "7px 13px 7px 8px",
                          borderRadius: "30px",
                          border: "1px solid #65dec7",
                          marginX: "10px",
                          alignItems: "center",
                        }}
                        key={val.id}>
                        <Box
                          component="img"
                          src={TickIMg}
                          sx={{
                            width: "17px",
                            height: "17px",
                            objectFit: "contain",
                            "&:hover": { transform: "scale(0.8)" },
                          }}
                        />
                        <TextView style={{ fontSize: "14px" }}>
                          {val.name}
                        </TextView>
                      </Box>
                    );
                  })}
              </Grid>
            )}
          </div>
        ))}
      </div>
    </Grid>
  );
}

export default MultiCheckBoxes;
